<template>
  <div class="edgeDetail">
    <div class="headerTop">
      <div class="rightTxt">
        <p class="font16 fonttwodark mb-24">基础信息</p>
        <p class="font20 fontdark">
          <span class="mr-16">{{ appForm.name }}</span>
          <tooltip-card
            :text="appForm.appDescribe"
            fontSize="14px"
            color="#919CAF"
            class="Describe"
          ></tooltip-card>
        </p>
        <p>
          <span class="mr-16">AppID：{{ appForm.id }}</span>
          <i
            class="icon tsit icon_fuzhi fontblue copyid fontcursor"
            data-clipboard-action="copy"
            :data-clipboard-text="appForm.id"
            @click="copyLink('.copyid')"
          ></i>
        </p>
        <p>
          <span class="mr-16">
            Secret Key：{{
            appForm.isShow ? appForm.appSecret : "********"
            }}
          </span>
          <i
            class="icon tsit icon_fuzhi fontblue copysecret fontcursor"
            data-clipboard-action="copy"
            :data-clipboard-text="appForm.appSecret"
            @click="copyLink('.copysecret')"
          ></i>
          <span class="ml-8 mr-8">|</span>
          <span class="fontblue fontcursor" @click="showPwd">
            {{
            appForm.isShow ? "隐藏密钥" : "显示密钥"
            }}
          </span>
        </p>
        <p class="address">
          <span class="mr-16">事件推送地址：{{ appForm.eventAddr || "暂无数据" }}</span>
        </p>
      </div>
      <div class="leftTxt">
        <div class="title">
          <h2>边缘计算设备</h2>
          <span>{{dataNum.boxNum}}</span>
        </div>
        <div class="title">
          <h2>事件数量</h2>
          <span>{{dataNum.eventNum}}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <titleStyle :txt="`设备列表(${totalCount})`" />
      <!-- 操作区域 -->
      <div class="inpBtn">
        <Input
          v-model="boxIdOrName"
          placeholder="请输入设备名称或设备编码"
          clearable
          style="width: 300px"
          @on-enter="searchBox"
          @on-clear="searchBox"
        />
        <Button type="primary" shape="circle" icon="ios-search" @click="searchBox">查询</Button>
      </div>
      <!-- 表格区域 -->
      <Table
        class="tableDom"
        ref="tableRef"
        highlight-row
        :columns="dataCol"
        :loading="tableLoading"
        :data="dataList"
      >
        <template slot-scope="{ row }" slot="status">
          <span>{{row.status == 0?'在线':'离线'}}</span>
        </template>
      </Table>
      <Row class="mt-16 mr-32" type="flex" justify="end">
        <Page
          :total="totalCount"
          :page-size="pageSize"
          :page-size-opts="psize"
          :current="pageIndex"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { getDetail, getCount, findBoxList } from "@/api/app";
import tooltipCard from "@/components/card/tooltip-card.vue";
import titleStyle from "@/components/titleStyle"; //通用标题
export default {
  components: { tooltipCard, titleStyle },
  data() {
    return {
      boxIdOrName: "",
      appForm: {},
      dataNum: {
        boxNum: 0,
        eventNum: 0
      },
      tableLoading: false,
      totalCount: 0,
      pageSize: 10,
      psize: [10, 20, 50, 100],
      pageIndex: 1,
      dataList: [
        {
          name: "的三大的",
          id: 100356,
          num: 2,
          time: "2022-3-22 10:11:11"
        },
        {
          name: "的三大的",
          id: 100356,
          num: 2,
          time: "2022-3-22 10:11:11"
        },
        {
          name: "的三大的",
          id: 100356,
          num: 2,
          time: "2022-3-22 10:11:11"
        },
        {
          name: "的三大的",
          id: 100356,
          num: 2,
          time: "2022-3-22 10:11:11"
        },
        {
          name: "的三大的",
          id: 100356,
          num: 2,
          time: "2022-3-22 10:11:11"
        }
      ],
      dataCol: [
        {
          title: "序号",
          type: "index",
          width: 120,
          align: "center"
        },
        {
          title: "设备名称",
          key: "name",
          tooltip: true
        },
        {
          title: "设备编码",
          key: "coding",
          tooltip: true
        },
        {
          title: "设备地址",
          key: "boxIp",
          tooltip: true
        },
        {
          title: "状态",
          slot: "status"
        }
      ]
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    }
  },
  created() {
    this.getDetail();
    this.getCount();
  },
  methods: {
    // 获取应用详情
    async getDetail() {
      let {
        data: { data: res }
      } = await getDetail(this.id);
      res.isShow = false;
      this.appForm = res;
      this.findBoxList(); //获取设备列表
    },
    // 边缘计算应用设备和事件数量
    async getCount() {
      let {
        data: { data: res }
      } = await getCount(this.id);
      console.log("res", res);
      this.dataNum = res;
    },
    searchBox() {
      this.pageIndex = 1;
      this.findBoxList();
    },
    // 设备列表
    async findBoxList() {
      this.tableLoading = true;
      let { id: applicationId, boxIdOrName, pageIndex, pageSize } = this;
      let params = {
        applicationId,
        boxIdOrName,
        pageIndex,
        pageSize
      };
      let {
        data: {
          data: res,
          page: { totalCount }
        }
      } = await findBoxList(params);
      this.dataList = res;
      this.totalCount = totalCount;
      this.tableLoading = false;
    },
    // 显示隐藏密钥
    showPwd() {
      this.appForm.isShow = !this.appForm.isShow;
    },
    // 复制
    copyLink(type) {
      let self = this;
      let clipboard = new Clipboard(type);
      clipboard.on("success", function() {
        self.$Message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", function() {
        self.$Message.success("复制失败");
        clipboard.destroy();
      });
    },
    // 页码改变的回调，返回改变后的页码
    handlePage(value) {
      this.pageIndex = value;
      this.findBoxList();
    },
    // 切换每页条数时的回调，返回切换后的每页条数
    sizeChange(value) {
      this.pageSize = value;
      this.findBoxList();
    }
  }
};
</script>

<style lang="scss" scoped>
.edgeDetail {
  .Describe {
    padding-left: 0 !important;
  }
  .headerTop {
    display: flex;
    justify-content: space-between;
    .leftTxt {
      display: flex;
      background: url("~@/assets/img/edge.png") no-repeat;
      background-size: 100% 100%;
    }
    .rightTxt {
      background: #ffffff;
    }
    div {
      width: 49%;
      // height: 240px;
      border-radius: 8px;
      padding: 24px 32px;
      .address {
        margin-bottom: 10px;
      }
      .title {
        display: flex;
        flex-direction: column;
        h2 {
          font-size: 24px;
          font-weight: 600;
        }
        span {
          margin-top: 10px;
          font-size: 18px;
        }
      }
    }
  }
  .footer {
    background: #ffffff;
    margin-top: 20px;
    // height: calc(100vh - 470px);
    padding: 24px 32px;
    .tableDom {
      margin-top: 20px;
    }
    .inpBtn {
      width: flex;
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      ::v-deep .ivu-btn {
        margin-left: 10px;
      }
    }
  }
}
</style>